module.exports = __webpack_public_path__ + "images/robot-2.png";